// Mirrors checkoutpage-api/src/checkout/address/getAddressData.ts.
// Pre-persistence chargeBody.fields entries carry the structured address in
// `value` as { billing, shipping?, sameAsShipping? }. After persistence
// (writeAddressField) `value` is a formatted display string and the structured
// data lives in `meta`. Use this helper anywhere you need the structured
// shape regardless of lifecycle stage.
export function getAddressData(field) {
  if (!field) return null;
  if (field.value && typeof field.value === 'object') return field.value;
  if (field.meta && typeof field.meta === 'object') return field.meta;
  return null;
}
